import React from 'react'
import { Navigate } from 'react-router-dom'
import SessionUseCase from 'domain/usecase/session/SessionService'
import SessionRepository from 'domain/repository/session/SessionRepository'
import OAuthRepository from 'domain/repository/oauth/OAuthRepository'
import { Button } from 'components/ui/button'

export default function LoginScreen() {
	const sessionUseCase = new SessionUseCase(new SessionRepository())
	const accessToken = sessionUseCase.getValidAccessTokenOrNull()

	if (accessToken != null) {
		return <Navigate to='/' replace />
	}

	const handleSignIn = () => {
		new OAuthRepository().startAuthorization()
	}

	return (
		<div className='min-h-screen flex'>
			{/* Left branding panel */}
			<div className='hidden lg:flex lg:w-[45%] relative overflow-hidden'>
				<img src='/image/placeholder_large.jpg' alt='' className='absolute inset-0 w-full h-full object-cover' />
				<div className='absolute inset-0 bg-black/65' />
				<div className='relative z-10 flex flex-col justify-center items-center p-12 text-white w-full'>
					<div className='space-y-4 text-center'>
						<h1 className='text-4xl font-bold leading-tight'>
							Открывайте лучшие
							<br />
							места рядом с вами
						</h1>
						<p className='text-white/60 text-lg'>Кафе, рестораны и заведения — с отзывами живых людей.</p>
					</div>
					<p className='text-white/30 text-sm absolute bottom-12'>© 2026 В двух шагах. Все права защищены.</p>
				</div>
			</div>

			{/* Right form panel */}
			<div className='flex-1 flex flex-col items-center justify-center p-6 bg-background'>
				<div className='w-full max-w-[360px] space-y-6'>
					<div className='space-y-1'>
						<h1 className='text-2xl font-bold tracking-tight'>Вход в аккаунт</h1>
						<p className='text-sm text-muted-foreground'>Войдите через приложение В двух шагах</p>
					</div>

					<Button className='w-full h-11' onClick={handleSignIn}>
						Войти
					</Button>
				</div>
			</div>
		</div>
	)
}
